import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'
import Button from '../Button'
import './styles.scss'

const ImageTeaser = ({ file, label, to, alt }) => (
  <div className="image-teaser">
    <GatsbyImage image={{ ...file.childImageSharp.gatsbyImageData, aspectRatio: 0.8 }} alt={alt} />
    <div className="image-teaser__button">
      <Button variant="primary" label={label} to={to} />
    </div>
  </div>
)

ImageTeaser.propTypes = {
  file: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  alt: PropTypes.string
}

export default ImageTeaser
